export { ROUTES, getProductDetailPath, getCategoryPath } from './routes';
export { BREAKPOINTS, mediaQueries } from './breakpoints';

export const USER_ROLES = {
  USER: 'user',
  ADMIN: 'admin',
};

export const ORDER_STATUS = {
  PENDING: 'pending',
  CONFIRMED: 'confirmed',
  SHIPPED: 'shipped',
  DELIVERED: 'delivered',
  CANCELLED: 'cancelled',
};
